// extracted by css-extract-rspack-plugin
export default {"alertError":"rKRXEZfyucQjPQ2C"};